import React, { useEffect, useState } from "react";
import "./ApiCall.style.scss";

import { Button, IconButton, InputLabel, FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import ReactJsonView from "react18-json-view";
import "react18-json-view/src/style.css";

import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "./../../Config/Config";
import ArrowDropDownSharpIcon from "@mui/icons-material/ArrowDropDownSharp";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import LoopIcon from "@mui/icons-material/Loop";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";

import { useNavigate, useLocation } from "react-router-dom";

// import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "./../../Config/Config";

import {
  fetchProducts,
  fetchModules,
  fetchEnvironments,
  fetchTestCasesfromModule,
} from "./../../API/CreateCollectionAPI";

import {
  ColorButton,
  StyledTableRow,
  StyledTableCell,
  PrimaryColor,
  SecondaryColor,
  BootstrapTooltip,
} from "./../common/common.Component";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { colorExport } from "./../common/common.Component";

import axios from "axios";
import JsonEditorPanel from "./JsonEditorPanel.component";
import { SaveAPI, fetchApiDetails, fetchAutoApiDetails } from "./../../API/Api";
import { CodeIcon } from "lucide-react";
import CurlImportDialog from "../../components-new/api/CurlImportDialog";

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FF6B00",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#FF8533",
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFB74D",
    color: "#FFFFFF",
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#2550D1",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#1B3AA3",
  },
  "&.Mui-disabled": {
    backgroundColor: "#A5B4E5",
    color: "#FFFFFF",
  },
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#FF6B00",
    height: 3,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    color: "#666666",
    "&:hover": {
      color: "#FF6B00",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#FF6B00",
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: "#666666",
  "&.Mui-selected": {
    color: "#FF6B00",
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const ControlsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  marginBottom: theme.spacing(3),
  backgroundColor: "#FFFFFF",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  border: "1px solid #E0E0E0",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
}));

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: "#333333",
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#666666",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#FFE0B2",
    },
    "&:hover fieldset": {
      borderColor: "#FFB74D",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#FF6B00",
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const colors = colorExport();

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      // sx={{ backgroundColor: colors.PrimaryColor }}
    >
      {value === index && (
        <Box sx={{ padding: "1rem" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const KeyValueEditor = ({ keyPair, setKeyPair, onKeyPairRemove }) => {
  const [keyValue, setKeyValue] = useState(keyPair);
  const [debouncedKeyValue, setDebouncedKeyValue] = useState(keyValue);

  useEffect(() => {
    setDebouncedKeyValue(keyValue);
  }, [keyValue]);

  useEffect(() => {
    setKeyPair(debouncedKeyValue);
    // eslint-disable-next-line
  }, [debouncedKeyValue]);

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        mb: 2,
        p: 1,
        borderRadius: 1,
        border: "1px solid #FFE0B2",
        backgroundColor: "#FFFFFF",
      }}
    >
      <CustomTextField
        size="small"
        onChange={(event) => {
          setKeyValue((prevState) => ({
            ...prevState,
            idapiparams: keyValue.idapiparams,
            [event.target.name]: event.target.value,
          }));
        }}
        variant="outlined"
        placeholder="Key"
        name="key"
        value={keyValue.key}
        sx={{ flex: 1 }}
      />
      <CustomTextField
        size="small"
        onChange={(event) => {
          setKeyValue((prevState) => ({
            ...prevState,
            idapiparams: keyValue.idapiparams,
            [event.target.name]: event.target.value,
          }));
        }}
        variant="outlined"
        placeholder="Value"
        name="value"
        value={keyValue.value}
        sx={{ flex: 1 }}
      />
      <StyledButton
        onClick={() => onKeyPairRemove(keyPair)}
        sx={{
          backgroundColor: "transparent",
          color: "#FF6B00",
          border: "1px solid #FF6B00",
          "&:hover": {
            backgroundColor: "#FFF5EB",
            borderColor: "#FF6B00",
          },
        }}
      >
        Remove
      </StyledButton>
    </Box>
  );
};

const requestMethods = [
  {
    slug: "get",
    method: "GET",
  },
  {
    slug: "post",
    method: "POST",
  },
  {
    slug: "put",
    method: "PUT",
  },
  {
    slug: "patch",
    method: "PATCH",
  },
  {
    slug: "delete",
    method: "DELETE",
  },
];

const ApiCall = (props) => {
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const [state, setState] = useState({
    productname: "",
    modulename: "",
    idproducts: props.idproducts,
    idmodules: props.idmodules,
    Type: "GET",
    reqUrl: `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=latestResult&companyid=${temp.companyid}`,
    body: "{\n\t\n}",
    browserDetails: [
      { browsername: "Chrome" },
      { browsername: "Edge" },
      { browsername: "Firefox" },
      { browsername: "Safari" },
      { browsername: "ALL" },
    ],
    version: 1,
    status: 0,
    resolutionDetails: [],
    envDetails: [],
    name: "",
    SelectEnvironmentName: props.SelectEnvironmentName,
    SelectEnvironmentUrl: props.SelectEnvironmentUrl || "",
    SelectResolution: "",
    SelectBrowserName: "Chrome",
    RerunFailTest: false,
    StopTestAfterFailue: false,
    Height: 0,
    Width: 0,
  });
  const [value, setValue] = useState(0);
  const [ParamPaneValue, setParamPaneValue] = useState([]);
  const [HeaderPaneValue, setHeaderPaneValue] = useState([]);
  const [responsevalue, setResponsevalue] = useState(0);
  const [testTabValue, setTestTabValue] = useState(0);

  const [body, setBody] = useState("{\n\t\n}");
  const [results, setResults] = useState("{\n\t\n}");
  const [header, setHeader] = useState("{\n\t\n}");
  const [curlDialogOpen, setCurlDialogOpen] = useState(false);

  const handleCurlImport = (parsedData) => {
    setState((prevState) => ({
      ...prevState,
      Type: parsedData.method,
      reqUrl: parsedData.url,
      body: parsedData.body || "{\n\t\n}",
      headers: parsedData.headers,
    }));

    if (parsedData.queryParams && parsedData.queryParams.length > 0) {
      setParamPaneValue(parsedData.queryParams);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const responsehandleChange = (event, newValue) => {
    setResponsevalue(newValue);
  };
  const onKeyPairAdd = (type) => {
    if (type === "Param") {
      // Generate a random number between 1000 and 9999
      let randnum = Math.floor(1000 + Math.random() * 9000);
      // };
      setParamPaneValue((ParamPaneValue) => [
        ...ParamPaneValue,
        {
          idapiparams: randnum,
          key: "",
          value: "",
        },
      ]);
    } else {
      setHeaderPaneValue((HeaderPaneValue) => [
        ...HeaderPaneValue,
        {
          idapiparams: "",
          key: "",
          value: "",
        },
      ]);
    }
  };

  const onKeyPairRemove = (keyPair, type) => {
    if (type === "Param") {
      let newKeyValues = [...ParamPaneValue];
      newKeyValues = newKeyValues.filter((x) => x.idapiparams !== keyPair.idapiparams);
      setParamPaneValue(newKeyValues);
    } else {
      let newKeyValues = [...HeaderPaneValue];
      newKeyValues = newKeyValues.filter((x) => x.idapiparams !== keyPair.idapiparams);
      setHeaderPaneValue(newKeyValues);
    }
  };

  const onKeyPairUpdate = (keyPair, type) => {
    if (type === "Param") {
      const elementIndex = ParamPaneValue.findIndex(
        (element) => element.idapiparams === keyPair.idapiparams,
      );
      let newKeyValues = [...ParamPaneValue];
      newKeyValues[elementIndex] = {
        ...newKeyValues[elementIndex],
        key: keyPair.key,
        value: keyPair.value,
      };
      setParamPaneValue(newKeyValues);
    } else {
      const elementIndex = HeaderPaneValue.findIndex(
        (element) => element.idapiparams === keyPair.idapiparams,
      );
      let newKeyValues = [...HeaderPaneValue];
      newKeyValues[elementIndex] = {
        ...newKeyValues[elementIndex],
        key: keyPair.key,
        value: keyPair.value,
      };
      setHeaderPaneValue(newKeyValues);
    }
  };

  const SendApiToSave = async (data) => {
    await SaveAPI(data)
      .then((response) => {
        if (response.status === 200) {
          // setPrevAPIList(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (props.apiData.newApi) {
      setBody("");
      setResults("");
      setState((prev) => {
        return {
          ...prev,
          reqUrl: `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?`,
          version: 1,
          status: 0,
          moduleId: props.moduleId,
          envurl: "",
          type: "GET",
          body: `{ }`,
          headers: `{ }`,
          name: "",
          tests: `{ }`,
        };
      });
    } else {
      if (props.value === "custom") {
        getApiDetails(props.apiData.idapi);
      } else if (props.value === "auto") {
        getAutoApiDetails(props.apiData.apiid);
      }
    }
  }, [props.apiData]);

  const getApiDetails = async (id) => {
    await fetchApiDetails(id)
      .then((response) => {
        if (response.status === 200) {
          setParamPaneValue((prev) => {
            return response.data.param.map((item) => {
              return {
                idapiparams: item.idapiparams,
                key: item.keyname,
                value: item.value,
              };
            });
          });

          setBody("");
          setResults("");
          setState((prev) => {
            const newState = {
              ...prev,
              reqUrl: response.data.url,
              name: response.data.name,
              version: response.data.version,
              status: response.data.status,
              moduleId: response.data.moduleId,
              envurl: response.data.envurl,
              Type: response.data.type,
              body: response.data.body,
              headers: response.data.headers,
              param: response.data.param,
              idapi: response.data.idapi,
              tests: response.data.tests || "",
            };
            return newState;
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAutoApiDetails = async (id) => {
    await fetchAutoApiDetails(id)
      .then((response) => {
        if (response.status === 200) {
          setBody("");
          setResults("");
          setState((prev) => {
            return {
              ...prev,
              reqUrl: response.data.url,
              // name: response.data.name,
              // version: response.data.version,
              // status: response.data.status,
              // moduleId: response.data.moduleId,
              // envurl: response.data.envurl,
              Type: response.data.type,
              body: response.data.body,
              headers: response.data.headers,
              tests: response.data.tests,
              // param: response.data.param,
              // idapi: response.data.idapi,
            };
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const callApi = async (data) => {
    const Response = await SaveAPI(data, "send")
      .then((response) => {
        if (response.status === 200) {
          // setPrevAPIList(response.data);
          setBody(response.data.response);
          return response;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return Response;
  };

  const callApiTest = async (data) => {
    const Response = await SaveAPI(data, "test")
      .then((response) => {
        if (response.status === 200) {
          // setPrevAPIList(response.data);
          setBody(response.data.response);
          setResults(response.data.result);
          return response;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return Response;
  };

  const handleTestTabChange = (event, newValue) => {
    setTestTabValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        backgroundColor: "#FFFFFF",
      }}
    >
      <ControlsContainer>
        <CustomTextField
          fullWidth
          onChange={(event) => {
            setState({
              ...state,
              name: event.target.value,
            });
          }}
          variant="outlined"
          label="API Name"
          value={state.name}
        />
        <ActionButton
          onClick={(e) => {
            SendApiToSave({
              url: state.reqUrl,
              version: state.version,
              status: state.status,
              moduleId: state.idmodules,
              envurl: state.SelectEnvironmentUrl,
              type: state.Type,
              body: state.body,
              headers: state.headers,
              newApi: props?.apiData?.newApi,
              idapi: state.idapi,
              name: state.name,
              param: ParamPaneValue,
              tests: state.tests,
            });
          }}
        >
          {props?.apiData?.newApi ? "Save" : "Update"}
        </ActionButton>
      </ControlsContainer>

      <ControlsContainer>
        <FormControl sx={{ minWidth: 120 }}>
          <Select
            size="small"
            value={state.Type === null ? "GET" : state.Type}
            onChange={(event) => {
              setState({
                ...state,
                Type: event.target.value,
              });
            }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#E0E0E0",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2550D1",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2550D1",
              },
            }}
          >
            {requestMethods.map((item, index) => (
              <MenuItem key={index} value={item.method}>
                {item.method}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <CustomTextField
          fullWidth
          onChange={(event) => {
            setState({
              ...state,
              reqUrl: event.target.value,
            });
          }}
          variant="outlined"
          label="Request URL"
          value={state.reqUrl}
        />
        <ActionButton
          onClick={() => setCurlDialogOpen(true)}
          startIcon={<CodeIcon />}
        >
          cURL Import
        </ActionButton>
        <ActionButton
          onClick={(e) => {
            callApi({
              url: state.reqUrl,
              version: state.version,
              status: state.status,
              moduleId: state.idmodules,
              envurl: state.SelectEnvironmentUrl,
              type: state.Type,
              body: state.body,
              headers: state.headers,
              newApi: props?.apiData?.newApi,
              name: state.name,
              idapi: state.idapi,
              tests: state.tests,
              param: ParamPaneValue,
            });
          }}
        >
          Call
        </ActionButton>
        <ActionButton
          onClick={(e) => {
            callApiTest({
              url: state.reqUrl,
              version: state.version,
              status: state.status,
              moduleId: state.idmodules,
              envurl: state.SelectEnvironmentUrl,
              type: state.Type,
              body: state.body,
              headers: state.headers,
              newApi: props?.apiData?.newApi,
              name: state.name,
              idapi: state.idapi,
              tests: state.tests,
              param: ParamPaneValue,
            });
          }}
        >
          Test
        </ActionButton>
      </ControlsContainer>

      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
        }}
      >
        <StyledTabs value={value} onChange={handleChange}>
          <StyledTab label="Query Params" />
          <StyledTab label="Headers" />
          <StyledTab label="Body" />
        </StyledTabs>

        <Box sx={{ p: 2 }}>
          <TabPanel value={value} index={0}>
            {ParamPaneValue && ParamPaneValue.length > 0
              ? ParamPaneValue.map((keyPair) => (
                  <KeyValueEditor
                    key={keyPair.idapiparams}
                    keyPair={keyPair}
                    setKeyPair={(keyPairValue) => onKeyPairUpdate(keyPairValue, "Param")}
                    onKeyPairRemove={() => onKeyPairRemove(keyPair, "Param")}
                  />
                ))
              : null}
            <ActionButton
              onClick={() => onKeyPairAdd("Param")}
              sx={{ mt: 1 }}
            >
              Add Parameter
            </ActionButton>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <JsonEditorPanel
              paneValue={state.headers}
              setPaneValue={(e) => {
                setState((prev) => ({
                  ...prev,
                  headers: e,
                }));
              }}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <JsonEditorPanel
              paneValue={state.body}
              setPaneValue={(e) => {
                setState((prev) => ({
                  ...prev,
                  body: e,
                }));
              }}
            />
          </TabPanel>
        </Box>
      </Box>

      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
        }}
      >
        <StyledTabs value={responsevalue} onChange={responsehandleChange}>
          <StyledTab label="Response" />
        </StyledTabs>
        <Box sx={{ p: 2 }}>
          <TabPanel value={responsevalue} index={0}>
            {typeof body === "string" ? (
              (() => {
                try {
                  return <ReactJsonView src={JSON.parse(body)} theme="vscode" />;
                } catch {
                  return <pre style={{ padding: "10px", background: "#f5f5f5" }}>{body}</pre>;
                }
              })()
            ) : (
              <ReactJsonView src={body} theme="vscode" />
            )}
          </TabPanel>
        </Box>
      </Box>

      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
        }}
      >
        <StyledTabs value={testTabValue} onChange={handleTestTabChange}>
          <StyledTab label="Tests" />
        </StyledTabs>
        <Box sx={{ p: 2 }}>
          <TabPanel value={testTabValue} index={0}>
            <JsonEditorPanel
              key={`tests-editor-${state.idapi}`}
              paneValue={state.tests || ""}
              setPaneValue={(e) => {
                setState((prev) => ({
                  ...prev,
                  tests: e,
                }));
              }}
            />
          </TabPanel>
        </Box>
      </Box>

      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
        }}
      >
        <StyledTabs value={responsevalue} onChange={responsehandleChange}>
          <StyledTab label="Test Results" />
        </StyledTabs>
        <Box sx={{ p: 2 }}>
          <TabPanel value={responsevalue} index={0}>
            <Box
              sx={{
                maxHeight: "400px",
                overflow: "auto",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                backgroundColor: "#F5F5F5",
                p: 2,
                borderRadius: 1,
              }}
            >
              {results}
            </Box>
          </TabPanel>
        </Box>
      </Box>

      <CurlImportDialog
        open={curlDialogOpen}
        onClose={() => setCurlDialogOpen(false)}
        onImport={handleCurlImport}
      />
    </Box>
  );
};

export default ApiCall;
